import { useContext } from 'react';
import { TrendsExplorerContext } from '../components/context/trends-explorer-context';
export const useTrendsExplorer = () => useContext(TrendsExplorerContext);